import { ObjectDeserializer } from 'object-deserializer';
import { dateToMoment } from '@utils/functions';
import stringOrNumberDeserializer from '@base/utils/stringOrNumberDeserializer';

import {
  LadderPlayer,
  RankedPlayer,
  Event,
  LadderNews,
  Standing,
  StatementEvent,
  Challenge,
  Talk,
  FindPlayer,
} from './interfaces';

export function findPlayerDeserializer(o: ObjectDeserializer): FindPlayer {
  return {
    userId: o.required('UserID').asString,
    userName: o.required('Usr').asString,
    gameId: o.required('GameID').asString,
    pref: o.optional('PREF')?.asNumber,
  };
}

export function ladderPlayerDeserializer(o: ObjectDeserializer): LadderPlayer {
  return {
    id: o.required('UserID').asString,
    userName: o.required('Usr').asString,
    avatar: o.optional('Avatar')?.asString,
    rank: o.required('Rank').asNumber,
  };
}

export function winnerDeserializer(o: ObjectDeserializer): LadderPlayer {
  return {
    id: o.required('UserID').asString,
    userName: o.required('Name').asString,
    rank: o.required('Rank').asNumber,
  };
}

export function rankedPlayerDeserializer(o: ObjectDeserializer): RankedPlayer {
  return {
    id: o.required('id').asString,
    name: o.optional('name')?.asString,
    posStart: o.optional('posStart')?.as(stringOrNumberDeserializer),
    posFinish: o.optional('posFinish')?.as(stringOrNumberDeserializer),
    isWinner: o.optional('isWinner')?.asNumber,
  };
}

export function rankingEventDeserializer(o: ObjectDeserializer): Event {
  return {
    date: o.required('date').asString,
    event_type: o.optional('event_type')?.asString,
    players: o.required('players').asArrayOfObjects(rankedPlayerDeserializer),
  };
}

export function ladderNewsDeserializer(o: ObjectDeserializer): LadderNews {
  return {
    id: o.required('NewsID').asString,
    news: o.required('News').asString,
    time: o.required('NewsTime').asString,
  };
}

export function statementEventDeserializer(
  o: ObjectDeserializer
): StatementEvent {
  return {
    transTime: o.required('TransTime').asString,
    event: o.required('Event').asString,
    pointsStamp: o.required('PointsStamp').asNumber,
    fee: o.optional('Fee')?.asString,
    rankFrom: o.optional('RankFrom')?.asNumber,
    rankTo: o.optional('RankTo')?.asNumber,
    tourneyID: o.optional('TourneyID')?.asString,
  };
}

function talkDeserializer(o: ObjectDeserializer): Talk {
  return {
    text: o.required('MessageText').asString,
    from: o.required('FromName').asString,
    time: o.required('MessageTime').asString,
  };
}

export function challengeDeserializer(o: ObjectDeserializer): Challenge {
  return {
    id: o.required('ChallengeID').asString,
    issuerId: o.optional('Issuer')?.asString,
    issuerName: o.optional('IssuerName')?.asString,
    recipientId: o.optional('Recipient')?.asString,
    recipientName: o.optional('RecipientName')?.asString,
    meetTime: o.optional('MeetTime')?.as(dateToMoment),
    talks: o.optional('talks')?.asArrayOfObjects(talkDeserializer),
  };
}
